var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name},[_c('div',{class:(_vm.name + "__point"),style:(_vm.pointStyle)}),_vm._v(" "),_c('div',{class:(_vm.name + "__base")}),_vm._v(" "),_c('div',{class:(_vm.name + "__progress"),style:({
      width: _vm.progressStyle.width,
      background: _vm.progressStyle.bgColor,
    })}),_vm._v(" "),_c('div',{class:(_vm.name + "__reflect"),style:({
      width: _vm.progressStyle.width,
      background: _vm.progressStyle.bgColor,
    })}),_vm._v(" "),_c('div',{class:(_vm.name + "__reflect-base")})])}
var staticRenderFns = []

export { render, staticRenderFns }